<template>
  <ul class="transfer-operation list-unstyled">
    <li>
      <t-button :type="rightButtonType" :disabled="!rightActive" size="sm" @click="$_onLeftButtonClick">
        <template v-if="operations.length <= 0">&lt;</template>
        <template v-else>{{ operations[0] }}</template>
      </t-button>
    </li>
    <li>
      <t-button :type="leftButtonType" :disabled="!leftActive" size="sm" @click="$_onRightButtonClick">
        <template v-if="operations.length <= 0">&gt;</template>
        <template v-else>{{ operations[1] }}</template>
      </t-button>
    </li>
  </ul>
</template>
<script>
import TButton from '../button/button.vue'

export default {
  name: 'TOperation',
  components: {TButton},
  props: {
    operations: {
      type: Array,
      default: () => []
    },
    size: {
      type: String,
      validator (value) {
        return ['', 'sm'].includes(value)
      }
    }
  },
  data: function () {
    return {
      leftActive: false,
      rightActive: false
    }
  },
  computed: {
    leftButtonType () {
      return this.$parent.leftCheckedKeys.length > 0 ? 'primary' : 'secondary'
    },
    rightButtonType () {
      return this.$parent.rightCheckedKeys.length > 0 ? 'primary' : 'secondary'
    }
  },
  methods: {
    $_onLeftButtonClick () {
      this.$parent && this.$parent.moveTo('left')
    },
    $_onRightButtonClick () {
      this.$parent && this.$parent.moveTo('right')
    }
  }
}
</script>



// WEBPACK FOOTER //
// operation.vue?00d8b224